import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieTouchIndicator.json';

const TouchIndicator = (props) => (
    <Icon iconName="TouchIndicator" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default TouchIndicator;
